import React, { useContext, useState } from 'react'
import "./ItemDetail.css";
import CartContext from '../../Context/CartContext'
import { Link } from 'react-router-dom';
import { ItemCount } from '../ItemCount/ItemCount';

export const ItemDetail = ({
  id,
  title,
  price,
  pictureUrl,
  category,
  description,
  forms,
}) => {
  const [quantity, setQuantity] = useState()
  const { addItem } = useContext(CartContext)

  const onAdd = (quantity) => {
    const productToAdd = {
      id,
      title,
      pictureUrl,
      category,
      description,
      forms,
      quantity,
      price
    }
    setQuantity(quantity)
    addItem(productToAdd, quantity)
  }


  return (
    <>
      <div className="card w-96 bg-base-100 shadow-2xl mb-8 detail">
        <figure>
          <img src={pictureUrl} alt={title} className="imgDetail"/>
        </figure>
        <div className="card-body p-2">
          <h2 className="card-title">{title}</h2>
          <p className="card-description">Descripción: {description}</p>
          </div>
          <div className='modalContainer'>
          <label htmlFor="my-modal" className="btn modal-button btnVer ">
            Ver presentaciones:
          </label>
          <div className="divider"></div> 

          <input type="checkbox" id="my-modal" className="modal-toggle" />
          <div className="modal">
            <div className="modal-box">
              <h3 className="font-bold text-lg">Presentaciones:</h3>
              <ul >
              {forms.map((el)=>(

                  <li key={el}>{el}</li>
                  ))}
              </ul>
              <div className="modal-action">
                <label htmlFor="my-modal" className="btn">
                  cerrar
                </label>
              </div>
            </div>
          </div>
        {
          quantity > 0 ? 
          <div className='flex flex-row justify-center items-center sm:flex-col md:flex-col'>
            <Link to={'/Productos'} className='m-5 btn modal-button'>Seguir comprando</Link>
            <Link className="m-5 btn btn-comprar"to={'/Cart'}>Ir al carrito</Link>
          </div>
           :
          <ItemCount stock={10} initial={1} onAdd={onAdd}/>
        }
        </div>
        </div>
    </>
  );
};
